import type {TextValueEditorLocalizations, TextValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';

/**
 * @ngdoc constant
 * @name TEXT_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.value-editors.text
 *
 * @description
 * For description see {@link TextValueEditorOptions}
 *
 * ```javascript
 *  {
 *      type: 'text',
 *      aceOptions: {
 *             useWrapMode: false,
 *             showGutter: true
 *         },
 *      prefix: undefined,
 *      suffix: undefined,
 *      includePrefixAndSuffixToModel: false,
 *      trim: false
 *  }
 * ```
 */
export const TEXT_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<TextValueEditorOptions> = {
    type: 'text',
    aceOptions: {
        useWrapMode: false,
        showGutter: true
    },
    prefix: undefined,
    suffix: undefined,
    includePrefixAndSuffixToModel: false,
    trim: false,
    switchToTextareaThreshold: 0
};

/**
 * @ngdoc constant
 * @name TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.text
 *
 * @description
 * ```
 * {
 *      description: ''
 * }
 * ```
 */
export const TEXT_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<TextValueEditorLocalizations>({
    description: ''
});